/**
 * Do not edit directly
 * Generated on Fri, 15 Dec 2023 21:20:39 GMT
 */

module.exports = {
  "button": {
    "borderRadius": {
      "value": "4px",
      "type": "dimension",
      "filePath": "./style-dictionary/temp/button/size/mode1.json",
      "isSource": true,
      "original": {
        "value": "{numeric.borderRadius.md}",
        "type": "dimension"
      },
      "name": "buttonBorderRadius",
      "attributes": {
        "category": "button",
        "type": "borderRadius"
      },
      "path": [
        "button",
        "borderRadius"
      ]
    }
  },
  "modal": {
    "borderRadius": {
      "value": "8px",
      "type": "dimension",
      "filePath": "./style-dictionary/temp/modal/size/mode1.json",
      "isSource": true,
      "original": {
        "value": "{numeric.borderRadius.lg}",
        "type": "dimension"
      },
      "name": "modalBorderRadius",
      "attributes": {
        "category": "modal",
        "type": "borderRadius"
      },
      "path": [
        "modal",
        "borderRadius"
      ]
    }
  },
  "numeric": {
    "borderRadius": {
      "md": {
        "value": "4px",
        "type": "dimension",
        "filePath": "./style-dictionary/temp/numeric/size/mode1/borderRadius.json",
        "isSource": true,
        "original": {
          "value": "{numeric.primitives.number_4}",
          "type": "dimension"
        },
        "name": "numericBorderRadiusMd",
        "attributes": {
          "category": "numeric",
          "type": "borderRadius",
          "item": "md"
        },
        "path": [
          "numeric",
          "borderRadius",
          "md"
        ]
      },
      "lg": {
        "value": "8px",
        "type": "dimension",
        "filePath": "./style-dictionary/temp/numeric/size/mode1/borderRadius.json",
        "isSource": true,
        "original": {
          "value": "{numeric.primitives.number_8}",
          "type": "dimension"
        },
        "name": "numericBorderRadiusLg",
        "attributes": {
          "category": "numeric",
          "type": "borderRadius",
          "item": "lg"
        },
        "path": [
          "numeric",
          "borderRadius",
          "lg"
        ]
      },
      "default": {
        "value": "4px",
        "type": "dimension",
        "filePath": "./style-dictionary/temp/numeric/size/mode1/borderRadius.json",
        "isSource": true,
        "original": {
          "value": "{numeric.borderRadius.md}",
          "type": "dimension"
        },
        "name": "numericBorderRadiusDefault",
        "attributes": {
          "category": "numeric",
          "type": "borderRadius",
          "item": "default"
        },
        "path": [
          "numeric",
          "borderRadius",
          "default"
        ]
      },
      "round": {
        "value": "56px",
        "type": "dimension",
        "filePath": "./style-dictionary/temp/numeric/size/mode1/borderRadius.json",
        "isSource": true,
        "original": {
          "value": "{numeric.primitives.number_56}",
          "type": "dimension"
        },
        "name": "numericBorderRadiusRound",
        "attributes": {
          "category": "numeric",
          "type": "borderRadius",
          "item": "round"
        },
        "path": [
          "numeric",
          "borderRadius",
          "round"
        ]
      },
      "sm": {
        "value": "2px",
        "type": "dimension",
        "filePath": "./style-dictionary/temp/numeric/size/mode1/borderRadius.json",
        "isSource": true,
        "original": {
          "value": "{numeric.primitives.number_2}",
          "type": "dimension"
        },
        "name": "numericBorderRadiusSm",
        "attributes": {
          "category": "numeric",
          "type": "borderRadius",
          "item": "sm"
        },
        "path": [
          "numeric",
          "borderRadius",
          "sm"
        ]
      },
      "xl": {
        "value": "16px",
        "type": "dimension",
        "filePath": "./style-dictionary/temp/numeric/size/mode1/borderRadius.json",
        "isSource": true,
        "original": {
          "value": "{numeric.primitives.number_16}",
          "type": "dimension"
        },
        "name": "numericBorderRadiusXl",
        "attributes": {
          "category": "numeric",
          "type": "borderRadius",
          "item": "xl"
        },
        "path": [
          "numeric",
          "borderRadius",
          "xl"
        ]
      }
    },
    "primitives": {
      "number_4": {
        "value": "4px",
        "type": "dimension",
        "filePath": "./style-dictionary/temp/numeric/size/mode1/primitives.json",
        "isSource": true,
        "original": {
          "value": "4px",
          "type": "dimension"
        },
        "name": "numericPrimitivesNumber4",
        "attributes": {
          "category": "numeric",
          "type": "primitives",
          "item": "number_4"
        },
        "path": [
          "numeric",
          "primitives",
          "number_4"
        ]
      },
      "number_8": {
        "value": "8px",
        "type": "dimension",
        "filePath": "./style-dictionary/temp/numeric/size/mode1/primitives.json",
        "isSource": true,
        "original": {
          "value": "8px",
          "type": "dimension"
        },
        "name": "numericPrimitivesNumber8",
        "attributes": {
          "category": "numeric",
          "type": "primitives",
          "item": "number_8"
        },
        "path": [
          "numeric",
          "primitives",
          "number_8"
        ]
      },
      "number_56": {
        "value": "56px",
        "type": "dimension",
        "filePath": "./style-dictionary/temp/numeric/size/mode1/primitives.json",
        "isSource": true,
        "original": {
          "value": "56px",
          "type": "dimension"
        },
        "name": "numericPrimitivesNumber56",
        "attributes": {
          "category": "numeric",
          "type": "primitives",
          "item": "number_56"
        },
        "path": [
          "numeric",
          "primitives",
          "number_56"
        ]
      },
      "number_2": {
        "value": "2px",
        "type": "dimension",
        "filePath": "./style-dictionary/temp/numeric/size/mode1/primitives.json",
        "isSource": true,
        "original": {
          "value": "2px",
          "type": "dimension"
        },
        "name": "numericPrimitivesNumber2",
        "attributes": {
          "category": "numeric",
          "type": "primitives",
          "item": "number_2"
        },
        "path": [
          "numeric",
          "primitives",
          "number_2"
        ]
      },
      "number_16": {
        "value": "16px",
        "type": "dimension",
        "filePath": "./style-dictionary/temp/numeric/size/mode1/primitives.json",
        "isSource": true,
        "original": {
          "value": "16px",
          "type": "dimension"
        },
        "name": "numericPrimitivesNumber16",
        "attributes": {
          "category": "numeric",
          "type": "primitives",
          "item": "number_16"
        },
        "path": [
          "numeric",
          "primitives",
          "number_16"
        ]
      },
      "number_24": {
        "value": "24px",
        "type": "dimension",
        "filePath": "./style-dictionary/temp/numeric/size/mode1/primitives.json",
        "isSource": true,
        "original": {
          "value": "24px",
          "type": "dimension"
        },
        "name": "numericPrimitivesNumber24",
        "attributes": {
          "category": "numeric",
          "type": "primitives",
          "item": "number_24"
        },
        "path": [
          "numeric",
          "primitives",
          "number_24"
        ]
      },
      "number_32": {
        "value": "32px",
        "type": "dimension",
        "filePath": "./style-dictionary/temp/numeric/size/mode1/primitives.json",
        "isSource": true,
        "original": {
          "value": "32px",
          "type": "dimension"
        },
        "name": "numericPrimitivesNumber32",
        "attributes": {
          "category": "numeric",
          "type": "primitives",
          "item": "number_32"
        },
        "path": [
          "numeric",
          "primitives",
          "number_32"
        ]
      },
      "number_40": {
        "value": "40px",
        "type": "dimension",
        "filePath": "./style-dictionary/temp/numeric/size/mode1/primitives.json",
        "isSource": true,
        "original": {
          "value": "40px",
          "type": "dimension"
        },
        "name": "numericPrimitivesNumber40",
        "attributes": {
          "category": "numeric",
          "type": "primitives",
          "item": "number_40"
        },
        "path": [
          "numeric",
          "primitives",
          "number_40"
        ]
      },
      "number_48": {
        "value": "48px",
        "type": "dimension",
        "filePath": "./style-dictionary/temp/numeric/size/mode1/primitives.json",
        "isSource": true,
        "original": {
          "value": "48px",
          "type": "dimension"
        },
        "name": "numericPrimitivesNumber48",
        "attributes": {
          "category": "numeric",
          "type": "primitives",
          "item": "number_48"
        },
        "path": [
          "numeric",
          "primitives",
          "number_48"
        ]
      }
    },
    "spacing": {
      "unit_1": {
        "value": "8px",
        "type": "dimension",
        "filePath": "./style-dictionary/temp/numeric/size/mode1/spacing.json",
        "isSource": true,
        "original": {
          "value": "{numeric.primitives.number_8}",
          "type": "dimension"
        },
        "name": "numericSpacingUnit1",
        "attributes": {
          "category": "numeric",
          "type": "spacing",
          "item": "unit_1"
        },
        "path": [
          "numeric",
          "spacing",
          "unit_1"
        ]
      },
      "unit_2": {
        "value": "16px",
        "type": "dimension",
        "filePath": "./style-dictionary/temp/numeric/size/mode1/spacing.json",
        "isSource": true,
        "original": {
          "value": "{numeric.primitives.number_16}",
          "type": "dimension"
        },
        "name": "numericSpacingUnit2",
        "attributes": {
          "category": "numeric",
          "type": "spacing",
          "item": "unit_2"
        },
        "path": [
          "numeric",
          "spacing",
          "unit_2"
        ]
      },
      "unit_3": {
        "value": "24px",
        "type": "dimension",
        "filePath": "./style-dictionary/temp/numeric/size/mode1/spacing.json",
        "isSource": true,
        "original": {
          "value": "{numeric.primitives.number_24}",
          "type": "dimension"
        },
        "name": "numericSpacingUnit3",
        "attributes": {
          "category": "numeric",
          "type": "spacing",
          "item": "unit_3"
        },
        "path": [
          "numeric",
          "spacing",
          "unit_3"
        ]
      },
      "unit_4": {
        "value": "32px",
        "type": "dimension",
        "filePath": "./style-dictionary/temp/numeric/size/mode1/spacing.json",
        "isSource": true,
        "original": {
          "value": "{numeric.primitives.number_32}",
          "type": "dimension"
        },
        "name": "numericSpacingUnit4",
        "attributes": {
          "category": "numeric",
          "type": "spacing",
          "item": "unit_4"
        },
        "path": [
          "numeric",
          "spacing",
          "unit_4"
        ]
      },
      "unit_5": {
        "value": "40px",
        "type": "dimension",
        "filePath": "./style-dictionary/temp/numeric/size/mode1/spacing.json",
        "isSource": true,
        "original": {
          "value": "{numeric.primitives.number_40}",
          "type": "dimension"
        },
        "name": "numericSpacingUnit5",
        "attributes": {
          "category": "numeric",
          "type": "spacing",
          "item": "unit_5"
        },
        "path": [
          "numeric",
          "spacing",
          "unit_5"
        ]
      },
      "unit_6": {
        "value": "56px",
        "type": "dimension",
        "filePath": "./style-dictionary/temp/numeric/size/mode1/spacing.json",
        "isSource": true,
        "original": {
          "value": "{numeric.primitives.number_56}",
          "type": "dimension"
        },
        "name": "numericSpacingUnit6",
        "attributes": {
          "category": "numeric",
          "type": "spacing",
          "item": "unit_6"
        },
        "path": [
          "numeric",
          "spacing",
          "unit_6"
        ]
      },
      "unitFourth": {
        "value": "2px",
        "type": "dimension",
        "filePath": "./style-dictionary/temp/numeric/size/mode1/spacing.json",
        "isSource": true,
        "original": {
          "value": "{numeric.primitives.number_2}",
          "type": "dimension"
        },
        "name": "numericSpacingUnitFourth",
        "attributes": {
          "category": "numeric",
          "type": "spacing",
          "item": "unitFourth"
        },
        "path": [
          "numeric",
          "spacing",
          "unitFourth"
        ]
      },
      "unitHalf": {
        "value": "4px",
        "type": "dimension",
        "filePath": "./style-dictionary/temp/numeric/size/mode1/spacing.json",
        "isSource": true,
        "original": {
          "value": "{numeric.primitives.number_4}",
          "type": "dimension"
        },
        "name": "numericSpacingUnitHalf",
        "attributes": {
          "category": "numeric",
          "type": "spacing",
          "item": "unitHalf"
        },
        "path": [
          "numeric",
          "spacing",
          "unitHalf"
        ]
      }
    }
  }
};
